<template>
  <div class="taskList">
    <div class="content">
      <van-collapse accordion @change="onChange" v-model="activeName">
        <van-collapse-item icon="/static/images/etv-folder.png" v-for="(item,index) in titelData" :key="index"
                           :title="item.EC_NAME" @touchstart.native.stop="gotouchstart(item,index)"
                           @touchmove.native="gotouchmove"
                           @touchend.native="gotouchend">

          <ul class="item-child" v-if="index === activeName">
            <li v-for="(it,i) in item.children" :key="i" class="Keylist" @click="goDetail(it)">
              <van-row style="width:100%;">
                <van-col :span="2">
                  <img style="width:20px;height:20px;" v-if="it.type == '1'" src="/static/images/tiHuan.png" alt="">
                  <img style="width:20px;height:20px;" v-else-if="it.type == '2'" src="/static/images/zhuiJia.png"
                       alt="">
                  <img style="width:20px;height:20px;" v-else-if="it.type == '3'" src="/static/images/chaBo.png" alt="">
                  <img style="width:20px;height:20px;" v-else-if="it.type == '4'" src="/static/images/sync.png" alt="">
                </van-col>
                <van-col :span="13" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                  {{ it.name }}
                </van-col>
                <van-col :span="9">
                   <span style="float:right;">
                      <van-button color="#ff0000" size="mini" plain @click.stop="deleTask(it.id,i)">删 除</van-button>
                      <van-button type="info" size="mini" @click.stop="sendTask(it)">发 送</van-button>
                    </span>
                </van-col>
              </van-row>
              <!--                <span style="height: 100%;display: flex;align-items:center;">-->
              <!--                  {{it.name}}-->
              <!--                </span>-->
              <!--                <span>-->
              <!--                  <van-button color="#ff0000" size="mini" plain-->
              <!--                              @click.stop="deleTask(it.id,i)">删 除</van-button>-->
              <!--                  <van-button type="info" size="mini" @click.stop="sendTask(it)">发 送</van-button>-->
              <!--                </span>-->
            </li>
          </ul>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="btns">
      <div>
        <van-button color="#409eff" size="small" @click="reload">刷新</van-button>
        <van-button color="#409eff" size="small" @click="dialogShow=true">新建分组</van-button>
        <van-button color="#409eff" size="small" @click="toNewTask">新建任务</van-button>
      </div>
    </div>
    <nut-dialog title="新建任务分组" :visible="dialogShow" @ok-btn-click="onsubmit"
                :closeOnClickModal="false"
                @close="inputDialogClose">
      <div>
        <nut-textinput
            v-model="taskGroupName"
            label="名称："
            placeholder="请输入组名"
            :clearBtn="false"
        />
      </div>
    </nut-dialog>

    <!--        设备列表---底部弹出---开始-->
    <van-action-sheet
        v-model=" isVisible1"
        :round="isRound"
    >
      <van-row style="height:40px;line-height:40px;border-bottom:1px solid #ddd;">
        <van-col :span="4">
          <van-button
              style="width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -14px;"
              @click="closeGroup" type="danger" size="small"
          >取消
          </van-button>
        </van-col>
        <van-col :span="16" style="text-align: center">设备列表</van-col>
        <van-col :span="4">
          <van-button
              style="width:100%;background:none;color:#1B89FA;border:none;line-height:40px;height:40px;text-indent: -14px;"
              @click="confirmSend" type="info" size="small"
          >确定
          </van-button>
        </van-col>
      </van-row>
      <div class="equirpGroupContent scroll">
        <van-collapse class="scroll-a" v-model="activeNames2" @change="onCollapseChange" accordion>
          <van-collapse-item v-for="(item,index) in menuItems2" :key="index" :name="index" :title="item.name"
                             icon="/static/images/etv-folder.png">
            <!--                        select保存复选框的选中的-->
            <van-checkbox-group v-model="select" @change="onCheckboxGroupChange" v-if="index === activeNames2">
              <van-cell-group>
                <van-cell
                    v-for="(item2,index2) in data"
                    :key="index2"
                    :title="item2.name"
                    value-class="value-class"
                    clickable
                    @click="toggle"
                    style="position: relative;"
                    :icon="item2.onlineState == '1' ? '/static/images/icon_dev_online.png' : '/static/images/icon_dev_disonline.png'"
                >
                  <van-checkbox :class="'checkboxes-'+index2" :name="item2.clId+'-'+item2.clNo" shape="square"/>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-collapse-item>
        </van-collapse>

      </div>
    </van-action-sheet>
    <!--        设备列表---底部弹出---结束-->
    <!--        节目列表---底部弹出---开始-->
    <van-action-sheet
        v-model="isVisible3"
        :round="isRound"
    >
      <van-row style="height:40px;line-height:40px;border-bottom:1px solid #ddd;">
        <van-col :span="4" offset="1">
          <van-button @click="closeGroup(2)" type="danger" size="small"
                      style="width:100%;background:none;color:#EE0A24;border:none;">取消
          </van-button>
        </van-col>
        <van-col :span="14" style="text-align: center">节目列表</van-col>
        <van-col :span="4" offset="0">
          <van-button @click="confirmSend3" type="info" size="small"
                      style="width:100%;background:none;color:#1B89FA;border:none;">确定
          </van-button>
        </van-col>
      </van-row>
      <div style="" class="equirpGroupContent">
        <!--                activeNames2展开的项的name,这里将index作为nme-->
        <van-collapse v-model="activeNames3" @change="onCollapseChange3">
          <van-collapse-item v-for="(item,index) in programsMenuItems3" :key="index" :name="index" :title="item.name"
                             icon="debit-pay">
            <!--                        select保存复选框的选中的-->
            <van-checkbox-group v-model="progrmasSelect3" @change="onCheckboxGroupChange3">
              <van-cell-group>
                <van-cell
                    v-for="(item2,index2) in item.children"
                    :key="index2"
                    :title="item2.name"
                    value-class="value-class"
                    clickable
                    @click="toggle"
                    style="position: relative;"
                >
                  <van-checkbox :class="'checkboxes-'+index2" :name="item2.pid" shape="square"/>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-action-sheet>
    <!--        节目列表---底部弹出---结束-->
  </div>
</template>

<script>
// import $ from 'jquery'
import qs from 'qs'
import {Toast} from 'vant'
import {Dialog} from 'vant'
import $ from "jquery"

import {mapMutations, mapActions} from 'vuex'

export default {
  name: 'taskList.vue',
  data() {
    return {
      groupName: '',
      dialogShow: false,
      titelData: [],
      activeName: '1',
      isVisible1: false,
      taskGroupName: '',
      menuItems2: [],
      isRound: false,
      activeNames2: '',
      chooseEquipArr: [],
      select: [],
      sendTaskId: '',
      isVisible3: false,
      activeNames3: ['1'],
      programsMenuItems3: [],
      progrmasSelect3: [],
      index: 0,
      data: [],
    }
  },
  computed: {},
  mounted() {
    this.getTaskData()
    this.$nextTick(() => {
      var winHeight = $(window).height()
      $(window).resize(function () {
        var thisWidth = $(this).height()
        if (winHeight > thisWidth) {
          $(".nut-tabbar").hide()
        } else {
          $(".nut-tabbar").show()
        }
      })
    })

    if (this.$route.query.taskId) {
      // this.isVisible1 = true
      this.sendTaskId = this.$route.query.taskId
    }
  },
  methods: {
    ...mapMutations(['reSetTaskId']),
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
    gotouchstart(item, index) {
      if (item.eid === "1") {
        return
      }
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
      this.longClick = 0
      this.timeOutEvent = setTimeout(() => {
        this.longClick = 1
        Dialog.confirm({
          title: '删除任务分组',
          message: '确认删除该分组吗？',
        }).then(() => {
          this.$ajax.post('/etv/selectEqTaskBindClOrPm.json', qs.stringify({
            id: item.eid,
            type: 'folder',
          })).then(res => {
            if (res.data.code === 0) {
              this.$ajax.post('/etv/deleteEquipmentTask.json', qs.stringify({
                id: item.eid,
                type: 'folder',
              })).then(res => {
                if (res.data.code === 0) {
                  Toast('删除成功')
                  this.titelData.splice(index, 1)
                } else {
                  Toast(res.data.msg)
                }
              })
            } else {
              Toast(res.data.msg)
            }
          })
        }).catch(() => {
        })

      }, 700)//这里设置定时
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gotouchend() {
      clearTimeout(this.timeOutEvent)
      if (this.timeOutEvent !== 0 && this.longClick === 0) {
        return
      }
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gotouchmove() {
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
    },

    getTaskData() {
      this.$ajax.post('/etv/selectEqTaskCategoryAlls.json', qs.stringify({
        ecType: '',
        type: '',
      })).then(res => {
        this.titelData = res.data.data.children
      })
    },
    onChange(activeName) {
      this.activeName = activeName
    },
    onsubmit() {
      let _this = this
      if (this.taskGroupName.length > 10) {
        Toast('字符长度必须在10位以内')
      } else {
        this.$ajax.post('/etv/insertTaskCategory.json', qs.stringify({
          name: _this.taskGroupName,
        })).then(res => {
          if (res.data.code === 0) {
            Toast('新建任务成功')
            this.getTaskData()
          } else {
            Toast('新建失败')
          }
          _this.dialogShow = false
          _this.taskGroupName = ''
        })
      }
    },
    deleTask(res) {
      Dialog.confirm({
        title: '删除'
        , message: '是否确定删除任务？',
      }).then(() => {
        this.$ajax.post('/etv/deleteEquipmentTask.json', qs.stringify({
          type: 'task',
          id: res,
        })).then(res => {
          if (res.data.code === 0) {
            Toast('删除成功')
            this.getTaskData()
          }
        })
      }).catch(() => {
      })

    },
    sendTask(res) {
      this.sendTaskId = res.id
      this.isVisible1 = true;
      this.$ajax.post('/etv/selectSeachClientTreeMobile.json', qs.stringify({
        groupParentId: '',
        type: '',
        onlineState: '',
        clientName: '',
      })).then(res => {
        this.menuItems2 = res.data.data
        // this.doch = document.getElementsByClassName('van-action-sheet')[0].offsetHeight;
        const Terminal = document.getElementsByClassName('scroll')[0]
        Terminal.addEventListener('scroll', this.handleScroll)
      })
    },
    switchActionSheet() {

    },
    reload: function () {
      this.titelData = []
      this.$emit('itemName', 'b')
      this.getTaskData()
    },
    goDetail(data) {
      this.reSetTaskId(data.id)
      this.$router.push({
        path: '/taskdetail', query: {
          id: data.id
        }
      })
      this.changeTopTitle('任务详情')
      this.changeTopIconStatus(true)
      this.setParentPage('programs')
    },
    onCollapseChange(activeNames2) {
      this.index = 0
      if (activeNames2 === '') {
        return
      }
      this.activeNames2 = activeNames2
      if (this.menuItems2[this.activeNames2].children.length > 0) {
        this.data = this.menuItems2[this.activeNames2].children.slice(this.index, 15)
      } else {
        this.data = []
      }
    },
    onCheckboxGroupChange() {

    },
    toggle() {
    },
    confirmSend() {
      if (this.select.length == 0) {
        Toast('请选择设备')
        return
      }

      let _this = this
      let postData = {
        ceEtId: _this.sendTaskId,
        clientNos: '',
        ids: '',
      }
      let equipArr = _this.select
      let clNoArr = [], clIdArr = []
      for (var i = 0; i < equipArr.length; i++) {
        clNoArr.push(equipArr[i].split('-')[1])
        clIdArr.push(equipArr[i].split('-')[0])
      }
      postData.clientNos = clNoArr.join(',')
      postData.ids = clIdArr.join(',')

      this.$ajax.post('/etv/insertClientEqTask.json', qs.stringify(postData)).then(res => {
        if (res.data.code == 0) {
          Toast('任务发送成功')
          _this.$emit('changeItemShow', 'c')
          // _this.$router.push({ path: '/programs', query: { itemName: 'c'} })
        } else {
          Toast(res.data.msg)
        }
        _this.isVisible1 = false
        _this.select = []
        _this.sendTaskId = ''

      })
    },
    closeGroup() {
      this.isVisible1 = false
      this.menuItems2 = []
      this.isVisible3 = false
      this.programsMenuItems3 = []
    },
    onCollapseChange3(activeNames3) {
      this.activeNames3 = activeNames3
    },
    confirmSend3() {
      if (this.progrmasSelect3.length == 0) {
        Toast('请选择节目')
        return
      }
      const a = this.progrmasSelect3.join(',')
      this.$router.push({path: '/addTask', query: {parentPage: 'taskList', grogramIds: a}})
    },
    toNewTask() {
      this.changeTopTitle('添加任务')
      this.setParentPage('programs')
      this.changeTopIconStatus(true)
      // this.isVisible3 = true
      // this.$ajax.post('/etv/selectProCategoryProgramMouldTree.json', qs.stringify({
      //   type: '1',
      // })).then(res => {
      //   this.programsMenuItems3 = res.data.data.pcList
      // })

      this.$router.push({path: '/addTask', query: {parentPage: 'taskList'}})
    },
    onCheckboxGroupChange3() {

    },
    inputDialogClose() {
      this.dialogShow = false
      this.isVisible1 = false
      this.isVisible3 = false
      this.taskGroupName = ''
      this.activeNames2 = ['1']
      this.select = []
      this.activeNames3 = ['1']
      this.progrmasSelect3 = []
    },
    handleScroll() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('scroll')[0].scrollTop
      let clientHeight = document.getElementsByClassName('scroll-a')[0].clientHeight
      //真实高度
      if (clientHeight - 640 - scrollHeight < 40) {
        if (this.menuItems2[this.activeNames2].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
          return
        }
        this.index++
        this.data = [...this.data, ...this.menuItems2[this.activeNames2].children.slice(this.index * 15, this.index * 15 + 15)]
      }
    },

  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.taskList {
  height: calc(100% - 0px);

  .equirpGroupContent {
    height: 25rem;
    overflow-y: auto;
    width: 100%;

    .van-collapse {
      height: 100%;
    }

    .van-collapse-item__content {
      padding: 0 16px;
    }

    .van-collapse-item__wrapper {
      position: relative;

      .van-cell {

        .van-checkbox {
          justify-content: flex-end;
        }
      }
    }
  }


  .btns {
    display: flex;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;

    .van-button {
      margin: 0 5px;
    }
  }

  .content {
    height: calc(100% - 40px);
    overflow-y: auto;

    .van-collapse-item__title--expanded {
      background: #409eff;
      color: #ffffff;

      .van-cell__right-icon {
        color: white;
      }
    }

    .van-collapse-item__content {
      padding: 0;
    }

    .item-child {
      list-style: none;
      padding: 0 16px;

      li {
        padding: 10px 0;
        line-height: 30px;
        position: relative;
        display: flex;
        justify-content: space-between;

        button {
          line-height: 22px;
        }

        img {
          height: 24px;
          margin-right: 10px;
        }

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: 1px solid $uni-border-bottom-color;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

      li:nth-last-child(1) {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: none;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }
    }
  }

  .van-cell__left-icon {
    line-height: 30px;
  }

  .van-button--mini{
    line-height: 30px;
  }

  .van-cell__title {
    line-height: 30px !important;
    font-size: 16px;

    .van-cell__right-icon {
      line-height: 30px;
    }

    .van-cell__left-icon {
      line-height: 30px;
    }
  }

  .Keylist {
    .van-col--2 {
      line-height: 30px;
      padding-top: 5px;
    }
  }

}
</style>
